import React from 'react';
import { Box, Stack, Text } from '@chakra-ui/react';

const DEFINITIONS = [
  {
    term: 'Co-branded App',
    definition:
      'means a HOVER App, HOVER Report, or HOVER Deliverable branded, distributed, or maintained with a Sponsor in accordance with Order Documentation;',
  },
  {
    term: 'Consumer User',
    definition:
      'means an individual (other than a Service Provider) who downloads and uses the HOVER App, or the customer of Sponsor who downloads and uses the HOVER App to transact with the Sponsor;',
  },
  {
    term: 'Customization Services',
    definition:
      'means those integration, software development and other customization services set forth on Order Documentation and performed by HOVER;',
  },
  {
    term: 'Data Privacy Laws',
    definition:
      'means the applicable privacy statute or regulation for the collection and processing of personal information or personal data according to the User’s jurisdiction, such as California Consumer Protection Act or General Data Protection Regulation, as amended;',
  },
  {
    term: 'Derived Data',
    definition:
      'means the Property Information, and Structure Measurements, collected through the Software and Services and derived through the HOVER Production Process to create a HOVER Model, including a HOVER Report, to the extent anonymized;',
  },
  {
    term: 'Estimation Platform',
    definition:
      'means the Quote-to-Order (Q2O) function within the HOVER App, excluding Sponsor information used to populate an Estimate Deliverable;',
  },
  {
    term: 'Estimate Deliverable',
    definition:
      'means forms and templates for generating a quote or ordering materials incident to Sponsored User directed services for a single Subject Property;',
  },
  { term: 'HOVER', definition: 'means Hover Inc., a Delaware corporation;' },
  {
    term: 'HOVER App',
    definition:
      'means a version of the HOVER mobile application and (and any companion applications to web-based tools through the HOVER Website) used to collect Image Data, view HOVER Models and order HOVER Models, and also includes all Co-branded Apps;',
  },
  {
    term: 'HOVER Deliverables',
    definition:
      'means the HOVER Models, Estimate Deliverable, TLA Premium or TLA Report or any other product and service related thereto ordered by or otherwise accessible by and made available to Users or Sponsors;',
  },
  {
    term: 'HOVER Membership Subscription',
    definition:
      'means all HOVER Membership features as set forth on the HOVER Website;',
  },
  {
    term: 'HOVER Model',
    definition:
      'means a digital version of HOVER’s 2D or 3D HOVER reconstruction of a Subject Property, of a type identified in the HOVER App or the HOVER Website (e.g. Roof Only or Complete, Expedited, TLA Premium, etc.) and generated through the HOVER Production Process, and which contains the Derived Data;',
  },
  {
    term: 'HOVER Production Process',
    definition:
      'means the propriety production process used by HOVER to create a HOVER Model;',
  },
  {
    term: 'HOVER Report',
    definition:
      'means a PDF version of a report that contains a representation of the HOVER Model and contains the Derived Data;',
  },
  {
    term: 'HOVER Web App',
    definition:
      'means the web application used to order, view and manage the HOVER Deliverables;',
  },
  {
    term: 'HOVER Website',
    definition:
      'means web-based tools and content available for access through www.hover.to;',
  },
  {
    term: 'Image Data',
    definition:
      'means the photos, images and other data, including without limitation, the geospatial and other metadata embedded in therein that is submitted or otherwise provided by User or Sponsor to HOVER through the HOVER App;',
  },
  {
    term: 'Order Documentation',
    definition:
      'means any agreement, order form, pricing addendum, or other ordering document used to purchase HOVER Deliverables and any subsequent amendment or addendum thereto entered into from time to time;',
  },
  {
    term: 'Property Information',
    definition:
      'means the address and location of the Subject Property, which may be derived through the Image Data or GPS information;',
  },
  {
    term: 'Service Provider',
    definition:
      'means a third party who downloads and uses the HOVER App to obtain a HOVER Model with respect to a Subject Property;',
  },
  {
    term: 'Software and Services',
    definition:
      'means collectively, the Customization Services, the HOVER App, the HOVER Web App, the Estimation Platform and the HOVER Deliverables engaged by a User or applicable Sponsor, as amended and supplemented from time to time;',
  },
  {
    term: 'Sponsor',
    definition:
      'means the HOVER licensee set forth on the Order Documentation who has contracted with HOVER to provide the Software and Services;',
  },
  {
    term: 'Structure Measurements',
    definition:
      'means the lines and measurements of a Subject Property derived by HOVER using the HOVER Production Process and if set forth on the Order Documentation, downloadable in .dwg, dxf or other file format or is readable through, inter alia, the .esx file format;',
  },
  {
    term: 'Subject Property',
    definition:
      'means the structure, location or premises being photographed by a User using the HOVER App and in respect of which a HOVER Model is produced;',
  },
  {
    term: 'Sponsored User',
    definition:
      'means the Sponsor’s employees, affiliates, Consumer User, and Service Providers authorized by Sponsor to use the HOVER App to order or receive HOVER Models;',
  },
  {
    term: 'TLA Premium',
    definition:
      'means a report with a total living square footage calculation, plus an exterior material calculation, which also includes a HOVER Model of a Subject Property;',
  },
  {
    term: 'TLA Report',
    definition:
      'means a report with a total living square footage calculation, but not including HOVER Model of a Subject Property; and',
  },
  {
    term: 'User',
    definition:
      'means each Consumer User, Sponsored User or a Service Provider, as applicable.',
  },
];

const DefinitionsSection = () => (
  <Stack spacing="3">
    {DEFINITIONS.map(({ term, definition }) => (
      <Box>
        <Text fontWeight="bold" as="span">{`"${term}" `}</Text>
        <Text as="span">{definition}</Text>
      </Box>
    ))}
  </Stack>
);

export default DefinitionsSection;
